import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@platform/ui';
import type { IDeleteSelectedDialogProps } from './IDeleteSelectedDialogProps';

/** Підтвердження масового видалення (UIUX patterns/confirmations): «Видалити N записів? Цю дію не можна скасувати.», «Скасувати» / «Видалити». */
export function DeleteSelectedDialog({ count, busy, onCancel, onConfirm }: IDeleteSelectedDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog title={t('listbar.deleteTitle')} onClose={onCancel}
      footer={<><Button onClick={onCancel}>{t('app.cancel')}</Button><Button variant="danger" disabled={busy} onClick={onConfirm}>{t('listbar.delete')}</Button></>}>
      <p style={{ margin: 0 }}>{t('listbar.deleteConfirm', { count })}</p>
    </Dialog>
  );
}
